import { useState } from "react";
import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useField, useFormikContext } from "formik";
import { customerKindEnum, isExists, params } from "../../utils";

import { useAppDispatch } from "../../app/hooks";
import { setDisabledFields } from "../../features/customer/customerSlice";
import { ApiSlice, useCreateMutation } from "../../features/api/Api";
import { saveHandler } from "../../handlers";
import Swal from "sweetalert2";
import { setAddressById } from "../../pages/applications/addresses/common";

function shouldBeStart(value: any) {
  if (value?.length === 11) {
    return true;
  } else {
    return false;
  }
}

function shouldBeClear(value: any, turmobInit: any, eInvoiceInit: any) {
  if (value?.length < 11 && (turmobInit || eInvoiceInit)) {
    return true;
  } else {
    return false;
  }
}

const TCInput = ({ name, ...otherProps }: any) => {
  const [create] = useCreateMutation();
  const [field, meta] = useField(name);
  const [turmobInit, setTurmobInit] = useState(false);
  const [eInvoiceInit, setEInvoiceInit] = useState(false);
  const { values, setFieldValue, errors }: any = useFormikContext();
  const dispatch = useAppDispatch();

  const handleChange = async (evt: any) => {
    const { value } = evt.target;

    field.onChange(evt);

    // Initialize e-invoice if true
    if (shouldBeStart(value)) {
      setEInvoiceInit(true);
      const result = await dispatch(
        ApiSlice.endpoints.getList.initiate({
          resource: `fixity/customer/eInvoice?vkntckn=${value}`,
        })
      );
      const { data: eInvoiceInfo }: any = result;

      if (
        isExists(eInvoiceInfo?.data) &&
        values.customerDetail.isEInvoiceUser !== eInvoiceInfo?.data
      ) {
        setFieldValue(
          "customerDetail.isEInvoiceUser",
          eInvoiceInfo.data,
          false
        );
      }
    }
    // End e-invoice

    // should turmob start check
    if (shouldBeStart(value)) {
      create({
        resource: "fixity/customer/customer/IsCustomerInBusinessPartner",
        params: { citizenOrTaxNumber: value },
      })
        .unwrap()
        .then(async (response: any) => {
          if (response.isSuccessful) {
            const result = await dispatch(
              ApiSlice.endpoints.getOneById.initiate({
                resource: `fixity/customer/customer`,
                id: response.data.id,
              })
            );

            const { data: customer }: any = result;

            const resultContact = await dispatch(
              ApiSlice.endpoints.getList.initiate({
                resource: `fixity/customer/contact/get-by-customerId/${response.data.id}`,
                params,
              })
            );

            const { data: contact }: any = resultContact;

            const resultAddress = await dispatch(
              ApiSlice.endpoints.getList.initiate({
                resource: `fixity/customer/address/get-by-customerId/${response.data.id}`,
                params,
              })
            );

            const { data: address }: any = resultAddress;
            const fullAddressList = setAddressById(
              address.data[0].fullAddressList
            );

            setFieldValue("isExistCustomer", true, false);
            setFieldValue("customerId", response.data.id);
            setFieldValue(
              "customerKindId",
              customer.data.customerKindId,
              false
            );

            if (customer?.data?.customerKindId === customerKindEnum.indivual) {
              setFieldValue("name", customer?.data?.name, false);
              setFieldValue("surname", customer?.data?.surname, false);
              setFieldValue("dateOfBirth", customer?.data?.dateOfBirth, false);
            } else {
              setFieldValue(
                "commercialTitle",
                customer?.data?.commercialTitle,
                false
              );
              setFieldValue("alias", customer?.data?.alias, false);
              setFieldValue("taxOfficeId", customer?.data?.taxOfficeId, false);
            }

            setFieldValue(
              "contact.jobTitleId",
              contact.data[0].jobTitleId,
              false
            );
            setFieldValue(
              "contact.isAuthorizedPerson",
              contact.data[0].isAuthorizedPerson,
              false
            );
            setFieldValue(
              "contact.isAuthorizedSignature",
              contact.data[0].isAuthorizedSignature,
              false
            );

            setFieldValue("contact.name", contact.data[0].name, false);
            setFieldValue("contact.surname", contact.data[0].surname, false);
            setFieldValue(
              "contact.dateOfBirth",
              contact.data[0].dateOfBirth,
              false
            );
            setFieldValue(
              "contact.identityNo",
              contact.data[0].identityNo,
              false
            );
            setFieldValue(
              "contact.contactIdentityInformation.fatherName",
              contact.data[0].contactIdentityInformation.fatherName,
              false
            );
            setFieldValue(
              "contact.contactIdentityInformation.motherName",
              contact.data[0].contactIdentityInformation.motherName,
              false
            );
            setFieldValue(
              "contact.contactIdentityInformation.documentNo",
              contact.data[0].contactIdentityInformation.documentNo,
              false
            );
            setFieldValue(
              "contact.contactIdentityInformation.validDate",
              contact.data[0].contactIdentityInformation.validDate,
              false
            );
            setFieldValue(
              "contact.contactCommunication.0.value",
              contact.data[0].contactCommunication[0].value,
              false
            );
            setFieldValue(
              "contact.contactCommunication.1.value",
              contact.data[0].contactCommunication[1].value,
              false
            );
            setFieldValue(
              "contact.signitureTypeId",
              contact.data[0].signitureTypeId,
              false
            );
            setFieldValue(
              "contact.contactIdentityInformation.genderId",
              contact.data[0].contactIdentityInformation.genderId,
              false
            );
            setFieldValue(
              "contact.departmentId",
              contact.data[0].departmentId,
              false
            );
            setFieldValue(
              "contact.contactIdentityInformation.socialStatusId",
              contact.data[0].contactIdentityInformation.socialStatusId,
              false
            );
            setFieldValue(
              "contact.contactIdentityInformation.identityCardTypeId",
              contact?.data[0]?.contactIdentityInformation?.identityCardTypeId,
              false
            );
            setFieldValue(
              "address.addressDetail.addressTypeId",
              address.data[0].addressDetail.addressTypeId,
              false
            );
            setFieldValue(
              "address.addressDetail.uniqueAddressCode",
              address.data[0].addressDetail.uniqueAddressCode,
              false
            );

            setFieldValue("address.name", address.data[0].name, false);
            setFieldValue("address.detail", address.data[0].detail, false);
            setFieldValue("address.city", fullAddressList?.city, false);
            setFieldValue("address.district", fullAddressList?.district, false);
            setFieldValue("address.door", fullAddressList?.door, false);
            setFieldValue("address.street", fullAddressList?.street, false);
            setFieldValue("address.town", fullAddressList?.town, false);
            setFieldValue("address.townShip", fullAddressList?.townShip, false);
            setFieldValue("address.village", fullAddressList?.village, false);
            setFieldValue("address.building", fullAddressList?.building, false);
          }
        })
        .catch((err) => {
          setFieldValue("isExistCustomer", false, false);
          create({
            resource: "fixity/customer/customer/IsCustomerInCrm",
            params: { citizenOrTaxNumber: value },
          })
            .unwrap()
            .then(async (responseCrm: any) => {
              if (responseCrm.isSuccessful) {
                setTurmobInit(true);
                Swal.fire(
                  "Uyarı!",
                  `Aboneye ait bilgileri görme yetkiniz yoktur.`,
                  "warning"
                );
              }
            })
            .catch(async (err) => {
              const result = await dispatch(
                ApiSlice.endpoints.getList.initiate({
                  resource: `fixity/customer/turmob?vkntckn=${value}`,
                })
              );

              const { data: turmobInfo }: any = result;

              if (turmobInfo?.data?.durum.sonuc) {
                setTurmobInit(true);
                // set corporate fields
                //setFieldValue("customerKindId", customerKindEnum.indivual, false);

                setFieldValue("name", turmobInfo.data.ad);
                setFieldValue("surname", turmobInfo.data.soyad);
                setFieldValue("contact.identityNo", value, false);
                setFieldValue("contact.name", turmobInfo.data.ad, false);
                setFieldValue("contact.surname", turmobInfo.data.soyad, false);
                const year = turmobInfo.data.kurulusTarihi.substring(0, 4);
                const month = turmobInfo.data.kurulusTarihi.substring(4, 6);
                const day = turmobInfo.data.kurulusTarihi.substring(6, 8);
                const dateOfBirth =
                  turmobInfo.data.kurulusTarihi === ""
                    ? null
                    : new Date(`${year}-${month}-${day}`);
                setFieldValue("dateOfBirth", dateOfBirth, false);
                setFieldValue("contact.dateOfBirth", dateOfBirth, false);

                // set disable filled fields
                dispatch(
                  setDisabledFields({
                    name: true,
                    surname: true,
                    commercialTitle: false,
                    alias: false,
                    isEInvoiceUser: true,
                    dateOfBirth: true,
                  })
                );

                // set address fields
                const address = turmobInfo.data?.adresBilgileri;
                if (address?.length > 0) {
                  const fields = [
                    "mahalleSemt",
                    "koy",
                    "caddeSokak",
                    "disKapiNo",
                    "icKapiNo",
                    "beldeBucak",
                    "ilceAdi",
                    "ilAdi",
                    "ilKodu",
                    "ilceKodu",
                  ];
                  const addressInfo = address[0];

                  let showAddress = "";
                  fields.map((item, index) => {
                    if (item === "disKapiNo" && isExists(addressInfo[item])) {
                      showAddress += `Dış kapı no: ${addressInfo[item]}`;
                    }
                    if (item === "icKapiNo" && isExists(addressInfo[item])) {
                      showAddress += `İç kapı no: ${addressInfo[item]}`;
                    }
                    if (isExists(addressInfo[item])) {
                      showAddress += `${addressInfo[item]} `;
                    }
                  });
                  if (isExists(showAddress)) {
                    setFieldValue("address.detail", showAddress, false);
                  }
                }
              } else {
                Swal.fire(
                  "Hata!",
                  turmobInfo?.data?.durum.hataDetayBilgisi,
                  "error"
                );
                //setFieldValue("citizenOrTaxNumber", "");
              }
            });
        });
    }

    // Set turmob false when tc is empty and turmob before start
    if (shouldBeClear(value, turmobInit, eInvoiceInit)) {
      setTurmobInit(false);
      setEInvoiceInit(false);
      setFieldValue("name", "", false);
      setFieldValue("surname", "", false);
      setFieldValue("dateOfBirth", null, false);
      setFieldValue("contact.identityNo", "", false);
      setFieldValue("contact.name", "", false);
      setFieldValue("contact.surname", "", false);
      setFieldValue("contact.dateOfBirth", "", false);
      const fields = {
        name: false,
        surname: false,
        commercialTitle: false,
        alias: false,
        isEInvoiceUser: true,
      };
      dispatch(setDisabledFields(fields));
    }
  };

  const configTextfield = {
    ...field,
    ...otherProps,
    fullWidth: true,
    onChange: handleChange,
  };

  return (
    <CssTextField
      inputProps={{ maxLength: 11, minLength: 11 }}
      value={isExists(field.value) ? field.value : ""}
      error={Boolean(meta.error)}
      helperText={meta.touched && meta.error}
      {...configTextfield}
    />
  );
};

const CssTextField = styled(TextField)(({ theme }) => ({
  "& label.Mui-focused": {
    color: "#0063cc",
  },
  "& label.Mui-disabled": {
    color:
      localStorage.getItem("dark") === "true"
        ? "rgba(255, 255, 255, 0.38) !important"
        : "rgba(0, 0, 0, 0.38)",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#0063cc",
  },
  ".MuiOutlinedInput-input.Mui-disabled": {
    textFillColor:
      localStorage.getItem("dark") === "true"
        ? "rgba(255, 255, 255, 0.38) !important"
        : "rgba(0, 0, 0, 0.38)",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor:
        theme.palette.mode === "dark" ? "rgb(204 204 204 / 45%)" : "#e5e5e5",
    },
    "&.Mui-disabled": {
      color:
        localStorage.getItem("dark") === "true"
          ? "rgba(255, 255, 255, 0.38)"
          : "rgba(0, 0, 0, 0.38)",
      fieldset: {
        borderColor:
          localStorage.getItem("dark") === "true"
            ? "rgba(255, 255, 255, 0.38)"
            : "rgba(0, 0, 0, 0.38)",
      },
    },

    "&:hover fieldset": {
      borderColor: "#0063cc",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#0063cc",
    },
  },
}));

export default TCInput;
